import { deleteContactUsMessage } from "../redux/slices/contactUsSlice"
import { fetchCouponUses } from "../services/couponService"
import baseEndpoints from "./baseEndpoints"

export default {
    login: `${baseEndpoints.user}login/`,
    logout: `${baseEndpoints.user}logout/`,
    googleOAuthLogin: `${baseEndpoints.user}google_oauth_signup_login/`,  // ADD THIS LINE
    
    fetchListOfAdmins: `${baseEndpoints.admin}fetch_list_of_admins/`,
    searchAndFilterAdminUsers: `${baseEndpoints.admin}search_and_filter_admins/`,
    fetchSingleAdminUser: (userId) => `${baseEndpoints.admin}get_admin_detail_information/?admin_id=${userId}`,
    updateAdminUser: `${baseEndpoints.admin}update_admin_detail_information/`,
    fetchListOfCustomerAccounts: `${baseEndpoints.user}get_list_of_all_user_accounts/`,

    // user manipulation endpoints
    deleteCustomerAccounts:`${baseEndpoints.user}delete_user_accounts/`,
    toggleUserAccountsStatus:`${baseEndpoints.user}toggle_user_accounts_status/`,

    searchAndFilterCustomerAccounts: `${baseEndpoints.user}filter_search_customer_information/`,
    fetchSingleCustomerAccount: (userId) => `${baseEndpoints.user}${userId}/get_single_user_information/`,
    updateCustomerAccount: (userId) => `${baseEndpoints.user}update_customer_information/?user_id=${userId}`,
    registerNewAccount: `${baseEndpoints.user}register_user/`,

    fetchListOfProductTemplates: `${baseEndpoints.product_template}get_all_templates/`,
    fetchCategoriesAndSubcategories: `${baseEndpoints.product_template}get_all_categories/`,
    searchAndFilterTemplates: (searchTerm, category, subCategory, status) => `${baseEndpoints.product_template}search_filter_templates/?search_term=${searchTerm}&category=${category}&sub_category=${subCategory}&status=${status}`,
    getSingleTemplateDetail: (templateId) => `${baseEndpoints.product_template}${templateId}/`,
    createTemplate: `${baseEndpoints.product_template}add_product_template/`,
    updateTemplate: (templateId) => `${baseEndpoints.product_template}${templateId}/update_product_template/`,
    deleteTemplates: `${baseEndpoints.product_template}delete_product_templates/`,


    fetchListOfProducts: `${baseEndpoints.product}get_all_products/`,
    fetchSingleProductDetail: (productId) => `${baseEndpoints.product}${productId}/`,
    searchAndFilterProducts: (searchTerm, category, subCategory, priceMin, priceMax, sockLevel, status_) => `${baseEndpoints.product}search_and_filter_products/?search_term=${searchTerm}&category=${category}&sub_category=${subCategory}&price_min=${priceMin}&price_max=${priceMax}&stock_level=${sockLevel}&status=${status_}`,
    updateProductDetail: (productId) => `${baseEndpoints.product}${productId}/update_product/`,
    toggleProductStatus: (productId) => `${baseEndpoints.product}${productId}/toggle_product_status/`,
    getAllProductDefaultProperties: `${baseEndpoints.product}get_all_product_constants_properties/`,
    delete_products: `${baseEndpoints.product}delete_products/`,


    fetchListOfOrders: `${baseEndpoints.order}get_all_orders/`,
    searchAndFilterOrders: `${baseEndpoints.order}search_and_filter_order_history/`,
    fetchSingleOrderDetail: (orderId) => `${baseEndpoints.order}get_detail_order_information/?order_uid=${orderId}`,
    updateOrderStatus: (orderId) => `${baseEndpoints.order}update_order_status/?order_uid=${orderId}`,

    fetchListPaymentsForTheAdmin: `${baseEndpoints.payment}fetch_list_of_payment_transactions/`,
    searchAndFilterPayments: (searchTerm) => `${baseEndpoints.payment}search_and_filter_payment_transaction/?search_term=${searchTerm}`,
    fetchSinglePaymentTransaction: (transactionId) => `${baseEndpoints.payment}fetch_single_payment_transaction_detail/?payment_id=${transactionId}`,

    adminReportAndAnalytics: `${baseEndpoints.report}`,
    adminDashboardReportAndAnalytics: `${baseEndpoints.report}dashboard/`,


    //  client side endpoints
    // fetchCategoriesAndSubcategories: `${baseEndpoints.product_template}get_all_categories/`,
    fetchInfoForHomePage: `${baseEndpoints.product}get_client_side_detail_for_home_page/`,
    fetchEnhancedHomePageData: `${baseEndpoints.product}get_enhanced_home_page_data/`,
    fetchMostCustomizedSection: `${baseEndpoints.product}get_most_customized_section/`,
    resetPassword: `${baseEndpoints.user}set_password_for_user/`,

    fetchListOfProductsBaseOnCategory: (categoryId) => `${baseEndpoints.product}get_client_side_products_for_category/?category_id=${categoryId}`,
    fetchListOfProductsBaseOnSubCategory: (subCategoryId) => `${baseEndpoints.product}get_client_side_products_for_sub_category_detail/?sub_category_id=${subCategoryId}`,
    addToProductOrProjectToFavorites: `${baseEndpoints.favorite_product}add_to_wishlist/`,
    fetchListOfProductsOrProjectsInFavorites: `${baseEndpoints.favorite_product}get_wishlist_items/`,
    removeProductOrProjectFromFavorites: (itemId) => `${baseEndpoints.favorite_product}remove_from_wishlist/?item_id=${itemId}`,
    fetchListOfProductsInCart: `${baseEndpoints.product_cart}get_list_of_products_in_cart/`,

    addProductToCart: `${baseEndpoints.product_cart}add_to_cart/`,
    removeProductFromCart: (itemId) => `${baseEndpoints.product_cart}remove_from_cart/?item_id=${itemId}`,
    searchAndFilterProductItems: `${baseEndpoints.product}search_and_filter_products_2/`,
    createContactUsMessage: `${baseEndpoints.user_contact_us}create_contact_us/`,

    fetchListOfContactUsMessages: `${baseEndpoints.user_contact_us}get_contact_us_list/`,
    searchContactUsMessages: (searchTerm) => `${baseEndpoints.user_contact_us}search_contact_us_message/?search_term=${searchTerm}`,
    fetchSingleContactUsMessage: (messageId) => `${baseEndpoints.user_contact_us}get_single_contact_us_message_detail/?contact_us_id=${messageId}`,
    updateContactUsMessage: `${baseEndpoints.user_contact_us}update_contact_us_message/`,
    deleteContactUsMessage: (messageId) => `${baseEndpoints.user_contact_us}delete_contact_us_message/?contact_us_id=${messageId}`,

    fetchTemplateDetailForDesigns: (subCategoryId) => `${baseEndpoints.design_product_templates}get_template_product_detail/?sub_category_id=${subCategoryId}`,
    saveCustomizeProductDesign: `${baseEndpoints.design_product_templates}save_customized_product/`,
    fetchCustomizedProductDesign: (projectId) => `${baseEndpoints.design_product_templates}${projectId}/load_design`,
    fetchCustomizedProductDesignDetail: (projectId) => `${baseEndpoints.design_product_templates}${projectId}/load_design_detail_product/`,
    updateCustomizedProductDesign: (projectId) => `${baseEndpoints.design_product_templates}${projectId}/update_customized_design/`,

    fetchAllUserCustomizedProductDesigns: `${baseEndpoints.design_product_templates}get_user_projects/`,
    filterUserCustomizedDesign: (searchTerm) => `${baseEndpoints.design_product_templates}search_filter_projects/?search_term=${searchTerm}`,
    deleteUserCustomizedDesign: (projectId) => `${baseEndpoints.design_product_templates}delete_project/?project_id=${projectId}`,


    fetch_product_available_specification_for_checkout: (productId) => `${baseEndpoints.order}fetch_product_available_specification_for_checking_out/?product_id=${productId}`,
    priceCalculatorBeforeCheckout: (productId) => `${baseEndpoints.order}before_checkout_temporary_price_calculation/?product_id=${productId}`,

    createOrder: `${baseEndpoints.payment}make_payment/`,
    addShippingAddress: `${baseEndpoints.payment}add_shipping_address/`,
    toggleSippingAddressStatus: (addressId) => `${baseEndpoints.payment}toggle_default_shipping_address/?address_id=${addressId}`,
    fetchPaymentDetailAfterPayment: (transactionId) => `${baseEndpoints.payment}fetch_single_payment_transaction_detail/?payment_id=${transactionId}`,

    fetchUserOrderHistory: `${baseEndpoints.order}get_user_order_history/`,
    searchAndFilterUserOrderHistory: `${baseEndpoints.order}search_and_filter_order_history_for_client/`,
    trackOrderStatus: (orderId) => `${baseEndpoints.order}track_order/?order_uid=${orderId}`,
    userMarkProductAsDelivered: (orderId) => `${baseEndpoints.order}mark_product_as_delivered/?order_uid=${orderId}`,
    addOrUpdateUserOrderFeedback: (orderId) => `${baseEndpoints.order}add_or_update_order_feedback/?order_uid=${orderId}`,
    deleteOrders: `${baseEndpoints.order}delete_orders/`,


    generate_coupon_codes: `${baseEndpoints.coupon}coupons/generate_codes/`,
    bulk_create_coupon_codes: `${baseEndpoints.coupon}coupons/bulk_create/`,
    fetchCoupon: (params) => `${baseEndpoints.coupon}coupons/?${params}`,
    toggleCouponStatus: (couponId) => `${baseEndpoints.coupon}coupons/${couponId}/toggle_status/`,
    deleteCoupon: (couponId) => `${baseEndpoints.coupon}coupons/${couponId}/`,
    create_coupon: `${baseEndpoints.coupon}coupons/`,
    update_coupon: (couponId) => `${baseEndpoints.coupon}coupons/${couponId}/`,
    fetchCouponAnalytics: `${baseEndpoints.coupon}coupons/analytics/`,
    fetchMostUsedCoupons: `${baseEndpoints.coupon}coupons/?ordering=-current_uses&page_size=10/`,
    downloadCouponCustomReport: (startDate, endDate) => {
        const fromDate = new Date(startDate);
        const toDate = new Date(endDate);
        return `${baseEndpoints.coupon}coupon-uses/usage_report/?date_from=${fromDate.toISOString()}&date_to=${toDate.toISOString()}`;
    },
    fetchExpiringCoupons: `${baseEndpoints.coupon}coupons/expiring_soon/`,
    fetchRecentCouponUsage: `${baseEndpoints.coupon}coupon-uses/`,

    fetchAvailableCouponsForCustomOrderAmount: (amount) => {
        return `${baseEndpoints.client_endpoints}available_for_order/?order_amount=${amount}`;
    },
    fetchCouponForFeaturedDeals: `${baseEndpoints.client_endpoints}featured_deals/`,
    fetchDueDateReachedCoupons: `${baseEndpoints.client_endpoints}expiring_soon/`,
    fetchCouponForFirstTimeCustomer: `${baseEndpoints.client_endpoints}first_time_offers/`,
    fetchClientCouponUsageHistory: `${baseEndpoints.client_endpoints}my_usage_history/`,
    fetchClientCouponForCategory: (categoryId) => {
        return `${baseEndpoints.client_endpoints}category_coupons/?category_id=${categoryId}`;
    },
    newsLaterSubscription: `${baseEndpoints.user}newsletter-subscribe/`,

}

